import React, { useMemo } from "react";
import "./DetailsPage.css";

const CallSummary = ({ bookingDetail }) => {
  const transcriptData = useMemo(() => {
    if (!bookingDetail?.consultation_summary) return null;
    try {
      const parsed = JSON.parse(bookingDetail.consultation_summary);
      if (Array.isArray(parsed)) return parsed;
      return bookingDetail.consultation_summary; // Fallback to raw string
    } catch (e) {
      return bookingDetail.consultation_summary; // Fallback to raw string
    }
  }, [bookingDetail?.consultation_summary]);

  return (
    <div className="p-6">
      <div className="flex flex-col gap-4">
        <h3 className="text-[#0A0A0A] text-lg font-bold px-3">Call Transcript</h3>
        <div className="">
          {transcriptData ? (
            <div className="bg-[#F8F9FA] p-4 rounded-lg border border-[#E0E0E0] mx-3 max-h-[500px] overflow-y-auto">
              {Array.isArray(transcriptData) ? (
                <div className="flex flex-col gap-2">
                  {transcriptData.map((item, idx) => (
                    <div key={idx} className="flex flex-col mb-2">
                      <span className={`font-bold text-sm ${item.speaker === "Doctor" || item.speaker === "doctor" ? "text-blue-600" : "text-green-600"}`}>
                        {item.speaker}:
                      </span>
                      <span className="text-[#4F4F4F] text-sm whitespace-pre-wrap">
                        {item.text}
                      </span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-[#4F4F4F] text-sm leading-relaxed whitespace-pre-wrap">
                  {transcriptData}
                </p>
              )}
            </div>
          ) : (
            <div className="flex justify-center items-center align-center w-[100%]">
              <p className="text-slate-400 text-[20px] text-center font-semibold pt-[5%] pb-[5%]">
                No transcript available for this consultation!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CallSummary;
